import { initGrapplerListeners } from './grapplerEvent';

/**
 * @param {object} data Page init data.
 * @param {string} [data.defaultGrapplerServiceName] Optional default service
 * name for every Grappler event fired from this page, taking precedence over
 * data.microsite.name. Individual track() calls can still override this per
 * event via grapplerServiceName on their own data payload (see
 * trackGrapplerEvent in grapplerEvent.js), which always wins over this
 * page-level default.
 */
const initAsync = (data) => {
  const market =
    data.culture && data.culture.market ? data.culture.market : null;
  const componentName =
    data.defaultGrapplerServiceName || data.microsite?.name || null;
  const environment = data.config && data.config.env ? data.config.env : null;
  initGrapplerListeners(environment, componentName, market);
};

export { initAsync };
